/** @format */

const template = `
<div class="search-filter">
  <ng-form name="filterSelectorForm" novalidate ng-model-options="{ updateOn: 'default' }">
    <div class="row" ng-if="ctrl.filterSearch">
      <div class="col-12">
        <ng-form ng-model-options="{debounce: 400}">
          <input
            class="form-control search-within-filter"
            type="text"
            placeholder="{{::'SEARCH.FILTER_SELECTOR.INPUT_PLACEHOLDER'|translate}}"
            ng-change="ctrl.startIndex = 0"
            ng-model="ctrl.searchWithinFilter" />
        </ng-form>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <ul class="filter-selectbox selectbox-multi">
          <li ng-if="ctrl.searching === true" translate="SEARCH.FILTER_SELECTOR.LOADING" class="loading-indicator"></li>
          <li
            ng-if="ctrl.searching === false && ctrl.allFilters.length === 0"
            translate="SEARCH.FILTER_SELECTOR.NO_RESULTS"
            class="loading-indicator"></li>
          <li
            ng-if="ctrl.isInitialized"
            ng-repeat="filterValue in ctrl.primaryFilters | filter: ctrl.filterMatchesSearch | limitTo: ctrl.filtersLimit: ctrl.startIndex as filteredFilters track by ($index+ctrl.startIndex)+ctrl.getFilterName(filterValue)">
            <label ng-if="::ctrl.isParentFilter(filterValue)" title="{{::ctrl.getFilterName(filterValue)}}"
              >{{::ctrl.getFilterName(filterValue)}}</label
            >
            <label
              ng-if="::!ctrl.isParentFilter(filterValue)"
              class="control control-checkbox sis-checkbox absolute-checkbox"
              data-cy="search-filter-option"
              data-filter-index="{{ctrl.getFilterIndex(filterValue)}}"
              title="{{::ctrl.getFilterName(filterValue)}}">
              {{::ctrl.getFilterName(filterValue)}}
              <input
                type="checkbox"
                ng-click="ctrl.toggleValue(filterValue, filterSelectorForm)"
                ng-checked="ctrl.isValueSelected(filterValue)"
                data-cy="search-filter-checkbox" />
              <div class="control-indicator"></div>
            </label>
          </li>
          <li ng-if="ctrl.primaryFilters.length > 0 && ctrl.secondaryFilters.length > 0" class="filter-divider"><hr /></li>
          <li
            ng-repeat="filterValue in ctrl.secondaryFilters | filter: ctrl.filterMatchesSearch | limitTo: ctrl.filtersLimit: ctrl.startIndex as filteredFilters track by ($index+ctrl.startIndex)+ctrl.getFilterName(filterValue)">
            <label ng-if="::ctrl.isParentFilter(filterValue)" title="{{::ctrl.getFilterName(filterValue)}}"
              >{{::ctrl.getFilterName(filterValue)}}</label
            >
            <label
              ng-if="::!ctrl.isParentFilter(filterValue)"
              class="control control-checkbox sis-checkbox absolute-checkbox"
              data-cy="search-filter-option"
              data-filter-index="{{ctrl.getFilterIndex(filterValue)}}"
              title="{{::ctrl.getFilterName(filterValue)}}">
              {{::ctrl.getFilterName(filterValue)}}
              <input
                type="checkbox"
                ng-click="ctrl.toggleValue(filterValue, filterSelectorForm)"
                ng-checked="ctrl.isValueSelected(filterValue)"
                data-cy="search-filter-checkbox" />
              <div class="control-indicator"></div>
            </label>
          </li>
        </ul>
      </div>
    </div>
    <div ng-if="ctrl.helpText || filteredFilters.length === ctrl.filtersLimit" class="row help-block">
      <div class="col-12">
        <p>{{::ctrl.helpText}}</p>
        <p
          ng-if="filteredFilters.length === ctrl.filtersLimit"
          translate="SEARCH.SEARCH_FILTER_SELECTOR.NUMBER_OF_MAX_OPTIONS_EXCEEDED"
          translate-values="{limit: ctrl.filtersLimit}"></p>
      </div>
    </div>
    <div class="row filter-preview-row">
      <div class="col-9">
        <div class="filter-preview-holder">
          <span class="filter-preview-title"> {{::ctrl.filterName|translate}} </span>
          <span class="filter-preview-content">
            <span ng-repeat="filterValue in ctrl.listSelected()" ng-class="{'item-separator': !$first}"
              >{{::ctrl.getFilterName(filterValue)}}</span
            >
          </span>
        </div>
      </div>
      <div class="col-3">
        <button
          type="submit"
          class="btn btn-lg btn-primary filter-submit"
          ng-click="ctrl.submitFilter()"
          ng-disabled="filterSelectorForm.$pristine"
          translate="SEARCH.FILTER_SELECTOR.OK"
          data-cy="search-filter-ok-button">
        </button>
      </div>
    </div>
  </ng-form>
</div>
`;
export default template;
